export default "__VITE_ASSET__QQw2bkGk__"